import axios from 'axios'
import { API_ROOT, HEADERS } from './constants/network'

export default axios.create({
  headers: HEADERS,
  baseURL: API_ROOT
})
